/**
 * PlaceImagesSection – Place images using the canonical MediaImageManager.
 * Mirrors producer ImagesSection pattern exactly.
 * Media pipeline (media_assets) is the single source of truth.
 */

import { MediaImageManager } from '@/components/media/MediaImageManager';
import { useMediaUpload } from '@/hooks/useMediaUpload';

interface PlaceImagesSectionProps {
  placeId?: string | null;
  draftSessionId?: string;
}

export function PlaceImagesSection({
  placeId,
  draftSessionId,
}: PlaceImagesSectionProps) {
  const effectiveOwnerId = placeId || undefined;
  const effectiveDraftSessionId = draftSessionId ?? '';

  const coverUpload = useMediaUpload({
    ownerType: 'place',
    ownerId: effectiveOwnerId ?? null,
    draftSessionId: !effectiveOwnerId ? effectiveDraftSessionId : undefined,
    kind: 'cover',
    maxFiles: 1,
  });

  const galleryUpload = useMediaUpload({
    ownerType: 'place',
    ownerId: effectiveOwnerId ?? null,
    draftSessionId: !effectiveOwnerId ? effectiveDraftSessionId : undefined,
    kind: 'gallery',
    maxFiles: 12,
  });

  return (
    <MediaImageManager
      ownerType="place"
      ownerId={effectiveOwnerId}
      draftSessionId={effectiveDraftSessionId}
      coverUpload={coverUpload}
      galleryUpload={galleryUpload}
      helperText="Ladda upp omslagsbild och galleri. Bilder sparas automatiskt."
    />
  );
}
